export const META_FIELDS = [
  "meta_created_by",
  "meta_updated_by",
  "meta_created_at",
  "meta_updated_at",
  "meta_expiry_date",
  "meta_active",
  "meta_tags",
];
